import { html } from "hono/html";

//#region src/swagger/renderer.ts
const RENDER_TYPE = {
	STRING_ARRAY: "string_array",
	STRING: "string",
	JSON_STRING: "json_string",
	RAW: "raw"
};
const RENDER_TYPE_MAP = {
	configUrl: RENDER_TYPE.STRING,
	deepLinking: RENDER_TYPE.RAW,
	presets: RENDER_TYPE.STRING_ARRAY,
	plugins: RENDER_TYPE.STRING_ARRAY,
	spec: RENDER_TYPE.JSON_STRING,
	url: RENDER_TYPE.STRING,
	urls: RENDER_TYPE.JSON_STRING,
	layout: RENDER_TYPE.STRING,
	docExpansion: RENDER_TYPE.STRING,
	maxDisplayedTags: RENDER_TYPE.RAW,
	operationsSorter: RENDER_TYPE.RAW,
	requestInterceptor: RENDER_TYPE.RAW,
	responseInterceptor: RENDER_TYPE.RAW,
	persistAuthorization: RENDER_TYPE.RAW,
	defaultModelsExpandDepth: RENDER_TYPE.RAW,
	defaultModelExpandDepth: RENDER_TYPE.RAW,
	defaultModelRendering: RENDER_TYPE.STRING,
	displayRequestDuration: RENDER_TYPE.RAW,
	filter: RENDER_TYPE.RAW,
	showExtensions: RENDER_TYPE.RAW,
	showCommonExtensions: RENDER_TYPE.RAW,
	queryConfigEnabled: RENDER_TYPE.RAW,
	displayOperationId: RENDER_TYPE.RAW,
	tagsSorter: RENDER_TYPE.RAW,
	onComplete: RENDER_TYPE.RAW,
	syntaxHighlight: RENDER_TYPE.JSON_STRING,
	tryItOutEnabled: RENDER_TYPE.RAW,
	requestSnippetsEnabled: RENDER_TYPE.RAW,
	requestSnippets: RENDER_TYPE.JSON_STRING,
	oauth2RedirectUrl: RENDER_TYPE.STRING,
	showMutabledRequest: RENDER_TYPE.RAW,
	request: RENDER_TYPE.JSON_STRING,
	supportedSubmitMethods: RENDER_TYPE.JSON_STRING,
	validatorUrl: RENDER_TYPE.STRING,
	withCredentials: RENDER_TYPE.RAW,
	modelPropertyMacro: RENDER_TYPE.RAW,
	parameterMacro: RENDER_TYPE.RAW
};
const renderSwaggerUIOptions = (options) => {
	return Object.entries(options).map(([k, v]) => {
		const key = k;
		if (!RENDER_TYPE_MAP[key] || v === void 0) return "";
		switch (RENDER_TYPE_MAP[key]) {
			case RENDER_TYPE.STRING: return `${key}: '${v}'`;
			case RENDER_TYPE.STRING_ARRAY:
				if (!Array.isArray(v)) return "";
				return `${key}: [${v.map((ve) => `${ve}`).join(",")}]`;
			case RENDER_TYPE.JSON_STRING: return `${key}: ${JSON.stringify(v)}`;
			case RENDER_TYPE.RAW: return `${key}: ${v}`;
			default: return "";
		}
	}).filter((item) => item !== "").join(",");
};

//#endregion
//#region src/swagger/resource.ts
const remoteAssets = ({ version }) => {
	const url = `https://cdn.jsdelivr.net/npm/swagger-ui-dist${version !== void 0 ? `@${version}` : ""}`;
	return {
		css: [`${url}/swagger-ui.css`],
		js: [`${url}/swagger-ui-bundle.js`]
	};
};

//#endregion
//#region src/index.ts
const SwaggerUI = (options) => {
	const asset = remoteAssets({ version: options?.version });
	delete options.version;
	if (options.manuallySwaggerUIHtml) return options.manuallySwaggerUIHtml(asset);
	const optionsStrings = renderSwaggerUIOptions(options);
	return `
    <div>
      <div id="swagger-ui"></div>
      ${asset.css.map((url) => html`<link rel="stylesheet" href="${url}" />`)}
      ${asset.js.map((url) => html`<script src="${url}" crossorigin="anonymous"><\/script>`)}
      <script>
        window.onload = () => {
          window.ui = SwaggerUIBundle({
            dom_id: '#swagger-ui',${optionsStrings},
          })
        }
      <\/script>
    </div>
  `;
};
const middleware = (options) => async (c) => {
	const title = options?.title ?? "SwaggerUI";
	return c.html(`
      <!doctype html>
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="description" content="SwaggerUI" />
          <title>${title}</title>
        </head>
        <body>
          ${SwaggerUI(options)}
        </body>
      </html>
    `);
};

//#endregion
export { SwaggerUI, middleware as swaggerUI };
//# sourceMappingURL=index.js.map